import React from 'react';
import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import './LuckyNumberModal.css';

const LuckyNumberModal = ({ luckyData, onClose }) => {
  if (!luckyData) return null;

  const { index, number, blocks, concatenated, hash, lastChar } = luckyData;

  const formatDateTime = (timestamp) => {
    return format(new Date(timestamp * 1000), 'yyyy-MM-dd HH:mm:ss', { locale: zhCN });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>幸运数字 #{index + 1}</h2>
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          {/* 区块信息 */}
          <section className="modal-section">
            <h3 className="section-title-small">6 个区块信息</h3>
            <div className="blocks-list">
              {blocks.map((block, idx) => (
                <div key={idx} className="block-item">
                  <div className="block-header">
                    <span className="block-label">区块 {idx + 1}</span>
                    <a
                      href={`https://mempool.space/block/${block.height}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block-link"
                    >
                      高度: {block.height}
                    </a>
                  </div>
                  <div className="block-info">
                    <div className="info-row">
                      <span className="info-label">时间:</span>
                      <span className="info-value">{formatDateTime(block.timestamp)}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Merkle Root:</span>
                      <code className="merkle-root">{block.merkle_root}</code>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 计算过程 */}
          <section className="modal-section">
            <h3 className="section-title-small">计算过程</h3>
            
            <div className="calculation-step">
              <div className="step-label">步骤 1: 连接 6 个 Merkle Roots</div>
              <div className="step-content">
                <code className="concatenated-text">{concatenated}</code>
              </div>
            </div>

            <div className="calculation-step">
              <div className="step-label">步骤 2: SHA256 哈希</div>
              <div className="step-content">
                <code className="hash-text">{hash}</code>
              </div>
            </div>

            <div className="calculation-step">
              <div className="step-label">步骤 3: 取最后一位十六进制</div>
              <div className="step-content">
                <div className="last-char-display">
                  最后一位: <span className="highlight">{lastChar}</span>
                </div>
              </div>
            </div>
          </section>

          {/* 结果 */}
          <section className="modal-section result-section">
            <h3 className="section-title-small">结果</h3>
            <div className="lucky-result">
              <span className="result-label">幸运数字:</span>
              <span className="result-number">{number}</span>
              <span className="result-hex">(0x{lastChar})</span>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LuckyNumberModal;
